import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const persiste = (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: "Oxe_Tech",
      storage,
      whitelist: ["auth", "user"],
    },
    reducers
  );

  return persistedReducer;
};

export default persiste;
